// import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    status: null,
    reason: '',
  },
  mutations: {
    updateStatus(state, value) {
      state.status = value;
    },
    updateReason(state, value) {
      state.reason = value;
    },
  },
  actions: {
  },
};
